export default "__VITE_ASSET__a792e1b1__"